import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import IntroPage from "@/pages/IntroPage";
import LandingPage from "@/pages/LandingPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import AuthPage from "@/pages/AuthPage";
import CustomerDashboard from "@/pages/CustomerDashboard";
import TherapistDashboard from "@/pages/TherapistDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import BookingForm from "@/pages/BookingForm";
import PaymentPage from "@/pages/PaymentPage";
import PaymentGateway from "@/pages/PaymentGateway";
import PaymentSuccess from "@/pages/PaymentSuccess";
import QueryWidget from "@/components/QueryWidget";
import GoaTravelersPage from "@/pages/GoaTravelersPage";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center">Loading...</div>
);

const ProtectedRoute = ({ user, loading, children }) => {
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/auth" />;
  return children;
};

const TherapistRoute = ({ user, loading, children }) => {
  if (loading) return <LoadingScreen />;
  if (!user || user.role !== 'therapist') return <Navigate to="/dashboard" />;
  return children;
};

const AdminRoute = ({ user, loading, children }) => {
  if (loading) return <LoadingScreen />;
  if (!user || (user.role !== 'admin' && user.role !== 'therapist')) return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      try {
        return JSON.parse(userData);
      } catch (error) {
        console.error('Failed to parse stored user', error);
        return null;
      }
    }
    return null;
  });
  const loading = false;

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-indigo-900 to-purple-800">Loading...</div>;
  }

  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={user ? <Navigate to="/dashboard" /> : <IntroPage />} />
          <Route path="/home" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <AuthPage setUser={setUser} />} />
          <Route path="/dashboard" element={<ProtectedRoute user={user} loading={loading}><CustomerDashboard user={user} setUser={setUser} /></ProtectedRoute>} />
          <Route path="/book" element={<ProtectedRoute user={user} loading={loading}><BookingForm user={user} /></ProtectedRoute>} />
          <Route path="/payment" element={<ProtectedRoute user={user} loading={loading}><PaymentPage /></ProtectedRoute>} />
          <Route path="/pay" element={<PaymentGateway />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentGateway />} />
          <Route path="/therapist" element={<TherapistRoute user={user} loading={loading}><TherapistDashboard user={user} setUser={setUser} /></TherapistRoute>} />
          <Route path="/admin" element={<AdminRoute user={user} loading={loading}><AdminDashboard user={user} setUser={setUser} /></AdminRoute>} />
        </Routes>

        {/* Global Query Widget - Available on all pages */}
        <QueryWidget />
      </BrowserRouter>
      </LanguageProvider>
      <Toaster />
    </div>
  );
}

export default App;
